// Basic helper functions for the site
import $ from 'jquery';
import { version } from "../js/constants";

let EsriModules;
//let toolIds = ["print", "search", "legend", "clear-graphics", "measurement"];
let toolIds = ["print", "search", "legend", "layer-list", "measurement"];
let measurementTools;
let measurementActiveTool = "distance";

export const initSite = (em) => {
  // console.log("Site->initSite");

  EsriModules = em;

  initMapLegend();
  initMeasurement();

  $("#main-version").html(version);

  $("#modal-accept-button").click(function () { hideModal(); });

  $("#main-left-close-panel").click(function () { closeSidebarPanel(); });
  $("#main-left-open-panel").click(function () { openSidebarPanel(); });

  $("#map-left-show-parcel-search").click(function () { showParcelSearchContainer(); });
  $("#header-right-toolbar-search").click(function () { toggleRightSideContainer("search", true); });
  $("#header-right-toolbar-print").click(function () { toggleRightSideContainer("print", true); });
  $("#header-right-toolbar-legend").click(function () { toggleRightSideContainer("legend", true); });
  // $("#header-right-toolbar-layer-list").click(function () { toggleRightSideContainer("layer-list", true); });
  $("#header-right-toolbar-measurement").click(function () { toggleMeasurementContainer(); });
  $("#header-right-menu").click(function () { toggleToolMenuContent(); });
  $("#header-right-menu-search").click(function () { showParcelSearch(); });
  $("#header-right-menu-legend").click(function () { showLegend(); });
  // $("#header-right-menu-layer-list").click(function () { showLayerList(); });

  $("#measurement-distance").click(function () { activateMeasurement("distance"); });
  $("#measurement-area").click(function () { activateMeasurement("area"); });
  $("#measurement-clear").click(function () { activateMeasurement("clear"); });
  // $("#main-clear-graphics-button").click(function () { deleteMapGraphics(); });
}

export const closeSidebarPanel = () => {
  $("#main-left").addClass("no-sidebar");
  $("#main-right").addClass("no-sidebar");
  $("#map-navigation").addClass("no-sidebar");
  $("#map-zoom-level").addClass("no-sidebar");
  $("#main-left-close-panel").hide();
  $("#main-left-open-panel").show();
};

export const openSidebarPanel = () => {
  $("#main-left").removeClass("no-sidebar");
  $("#main-right").removeClass("no-sidebar");
  $("#map-navigation").removeClass("no-sidebar");
  $("#map-zoom-level").removeClass("no-sidebar");
  $("#main-left-open-panel").hide();
  $("#main-left-close-panel").show();
};

export const displayMessage = (div, msg) => {
  $(div + "-message").html(msg);
  $(div + "-message").show();
  $(div + "-error").hide();
};
export const addToDisplayMessage = (div, msg, newLine) => {
  let elem = div + "-message";
  let crntMsg = $(elem).html();
  if (newLine) crntMsg += "</br>";
  $(elem).html(crntMsg + msg);
};
export const displayError = (div, msg) => {
  $(div + "-error").html(msg);
  $(div + "-error").show();
  $(div + "-message").hide();
};
export const hideInfo = (div) => {
  $(div + "-message").hide();
  $(div + "-error").hide();
};
export const getFormattedDate = (msDate, includeTime, addHours = 0) => {
  if (!msDate) return "";
  let date = new Date(msDate);
  if (addHours !== 0) date.setHours(date.getHours() + addHours);
  let formattedDate = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear();
  if (includeTime) {
    let hours = date.getHours();
    let ampm = hours < 12 ? "AM" : "PM";
    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours -= 12;
    }
    let mins = date.getMinutes();
    if (mins < 10) mins = "0" + mins;
    formattedDate += " " + hours + ":" + mins + " " + ampm;
  }

  return formattedDate;
};
export const trimDecimalPlaces = (num, fractDigits) => {
  if (!num) return num;
  return Number(num.toFixed(fractDigits));
}
export const formatNumber = (num, fractDigits) => {
  if (!num) return "0";
  return parseInt(num).toLocaleString("en-US",
    {
      minimumFractionDigits: fractDigits,
      maximumFractionDigits: fractDigits
    }
  );
};
export const iFrameDataUriTest = function (src) {
  let support, iframe = document.createElement('iframe');

  iframe.style.display = 'none';
  iframe.setAttribute('src', src);

  document.body.appendChild(iframe);

  try {
    support = !!iframe.contentDocument;
  } catch (e) {
    support = false;
  }

  document.body.removeChild(iframe);

  return support;
};

export const buildListItem = (id, recLabel, recNum, html, clickFunction) => {
  let mainDiv = $("<div />", {
    id: id + recNum,
    class: "list-item"
  });

  let div = $("<div />", {
    class: "line-item"
  });

  let span = $("<span />", {
    class: "record",
    text: recLabel + " " + (recNum + 1)
  });

  let i = $("<i />", {
    class: "fas fa-eye"
  }).on('click', function () {
    clickFunction(recNum);
  });
  div.append(span);
  div.append(i);
  mainDiv.append(div);

  div = $("<div />", {
    class: "item-detail"
  });
  div.append(html);
  mainDiv.append(div);

  $(id + "records").append(mainDiv);
}

export const buildLinkListItem = (id, recNum, name, url, address, clickFunction) => {
  let mainDiv = $("<div />", {
    id: id + recNum,
    class: "link-item"
  });

  let div = $("<div />", {
    class: "line-item"
  });

  let span = $("<span />", {
    class: "desc"
  });

  if (url) {
    let a = $("<a />", {
      href: url,
      target: "_blank",
      text: name
    });
    span.append(a);
  } else {
    span.append(name);
  }

  let i = $("<i />", {
    class: "fas fa-eye"
  }).on('click', function () {
    clickFunction(recNum);
  });
  div.append(span);
  div.append(i);
  mainDiv.append(div);

  if (address) {
    div = $("<div />", {
      class: "address",
      text: address
    });
    mainDiv.append(div);
  }

  $(id + "records").append(mainDiv);
}

function initMeasurement() {
  measurementTools = new EsriModules.Measurement({
    view: EsriModules.mapView,
    activeTool: null,
    areaUnit: "square-us-feet",
    linearUnit: "us-feet",
    container: "main-measurement-content"
  });
}

function initMapLegend() {
  let layers = EsriModules.mapView.map.layers.items;
  let layer;
  for (let idx = 0, len = layers.length; idx < len; idx++) {
    if (layers[idx].id === "landRecordsLayer") {
      layer = layers[idx];
      break;
    }
  }
  let legend = new EsriModules.Legend({
    view: EsriModules.mapView,
    layerInfos: [{
      layer: layer,
      title: "Land Records"
    }],
    container: "main-legend-content"
  });

  // let ll = new EsriModules.LayerList({
  //   view: EsriModules.mapView,
  //   title: "Map Features",
  //   container: "main-layer-list-content",
  // });
}

function toggleRightSideContainer(toolId, noOthers) {
  if (noOthers) clearSelectedTool(toolId);
  if ($("#main-" + toolId + "-container").is(":visible")) {
    $("#header-right-toolbar-" + toolId).removeClass("toolbar-option-selected");
    $("#main-" + toolId + "-container").hide();
  } else {
    $("#header-right-toolbar-" + toolId).addClass("toolbar-option-selected");
    $("#main-" + toolId + "-container").show();
  }
};

function clearSelectedTool(toolId) {
  for (let idx = 0; idx < toolIds.length; idx++) {
    if (toolIds[idx] !== toolId) {
      $("#main-" + toolIds[idx] + "-container").hide();
      $("#header-right-toolbar-" + toolIds[idx]).removeClass("toolbar-option-selected");
      if (toolIds[idx] === "measurement") clearMeasurement();
    }
  }
}

function toggleMeasurementContainer() {
  toggleRightSideContainer("measurement", true);
  if (!$("#main-measurement-container").is(":visible")) {
    clearMeasurement();
    return;
  }
  if (!measurementActiveTool) measurementActiveTool = "distance";
  activateMeasurement(measurementActiveTool);
}
function clearMeasurement() {
  measurementTools.clear();
  $(".measurement-message-container").hide();
  $(".measurement-buttons span").removeClass("tool-selected");
}

function activateMeasurement(type) {
  $(".measurement-message-container").hide();
  $(".measurement-buttons span").removeClass("tool-selected");
  switch (type) {
    case "distance":
      measurementActiveTool = "distance";
      $("#measurement-distance").addClass("tool-selected");
      break;
    case "area":
      measurementActiveTool = "area";
      $("#measurement-area").addClass("tool-selected");
      break;
    case "clear":
      measurementActiveTool = null;
      measurementTools.clear();
      $(".measurement-message-container").show();
      displayMessage("#main-measurement", "Graphics have been cleared.");
      break;
  }
  measurementTools.activeTool = measurementActiveTool;
}

export const toggleParcelSearchContainer = () => {
  if ($("#main-basemap-gallery-container").is(":visible")) toggleBasemapGallery();
  if ($("#main-print-container").is(":visible")) togglePrintContainer();

  if ($("#main-search-container").is(":visible")) {
    $("#header-right-toolbar-search").removeClass("toolbar-option-selected");
    $("#main-search-container").hide();
  } else {
    $("#header-right-toolbar-search").addClass("toolbar-option-selected");
    $("#main-search-container").show();
  }
};
export const showParcelSearchContainer = () => {
  if ($("#main-search-container").is(":visible")) return;
  toggleRightSideContainer("search", true);
}

function hideModal() {
  $("#modal-disclaimer-window").removeClass("show");
}

function toggleToolMenuContent() {
  if ($("#header-right-menu-content").is(":visible")) {
    $("#header-right-menu-content").hide();
  } else {
    $("#main-search-container").hide();
    $("#main-legend-container").hide();
    $("#main-layer-list-container").hide();
    $("#header-right-menu-content").show();
    $("#sidebar-option-menu-content").hide();
  }
}

function showParcelSearch() {
  $("#header-right-menu-content").hide();
  $("#main-search-container").show();
}

function showLegend() {
  $("#header-right-menu-content").hide();
  $("#main-legend-container").show();
}

function showLayerList() {
  $("#header-right-menu-content").hide();
  $("#main-layer-list-container").show();
}
